export default __webpack_public_path__ + "images/FU.1dd9d7c.png";